import _ from 'lodash'
import {Echo} from '../../common/socket'

export default {
  props: ['session'],
  data() {
    return {
      records: this.session.records || [],
      activePageCount: null
    }
  },
  computed: {
    book() {
      return _.get(this.session, 'publication.book')
    },
    chapters() {
      return _.get(this.session, 'publication.content.chapters', [])
    },
    pages() {
      return _.flatMap(this.chapters, 'pages')
    },
    sorted() {
      let recs = _.sortBy(this.records, (record) => {
        return -record.composite_score
      })
      return recs.filter((record) => {
        // for now, we don't want to display LMS records to the facilitator or leaderboard
        return record.lms === 0
      })
    },
    idealTextQuestions() {
      let chapters = _.cloneDeep(this.session.publication.content.chapters);
      let pages = _.flatMap(chapters, 'pages');
      return _.filter(pages, (page) => {
        page.layout === 'IdealTextQuestion';
      });
    },
    brandColors() {
      return {
        primary: this.book.config.theme.vars.footer_meter_1_color || '#D52B1E',
        secondary: this.book.config.theme.vars.footer_meter_2_color || '#82786F',
        tertiary: this.book.config.theme.vars.footer_meter_3_color || '#263F6A',
        meter4: this.book.config.theme.vars.footer_meter_4_color || '#263F6A',
        meter5: this.book.config.theme.vars.footer_meter_5_color || '#263F6A',
        meter6: this.book.config.theme.vars.footer_meter_6_color || '#263F6A',
        meter7: this.book.config.theme.vars.footer_meter_7_color || '#263F6A',
      }
    },
    hasStopPage() {
      let stopPages = _.filter(this.pages, (page) => {
        return page.layout === 'Stop';
      })
      return (stopPages.length > 0) ? true : false;
    },
    subSessions() {
      return _.get(this.session, 'publication.content.sub_sessions', [])
    }
  },
  methods: {
    getMeterColorMap() {
      return {
        'meter-1': this.brandColors?.primary,
        'meter-2': this.brandColors?.secondary,
        'meter-3': this.brandColors?.tertiary,
        'meter-4': this.brandColors?.meter4,
        'meter-5': this.brandColors?.meter5,
        'meter-6': this.brandColors?.meter6,
        'meter-7': this.brandColors?.meter7,
      }
    },
    getIndex(page) {
      return _.findIndex(this.pages, {id: page.id})
    },
    calcActivePageCount(disabled_chapters) {
      console.log('caclulating active page count')
      let chapters = _.cloneDeep(this.session.publication.content.chapters)
      _.remove(chapters, function (chapter) {
        return _.includes(disabled_chapters, chapter.id)
      })
      let pages = _.flatMap(chapters, 'pages')
      console.log(pages.length)
      this.activePageCount = pages.length + 1; //add 1 to account for data-entry page
    },
    isQuestion(record) {
      try {
        let locationIndex = this.getLocationIndex(record)
        let flow = record.bookmark.history[locationIndex - 1]
        let page = _.filter(this.pages, function (p) {
          return (p.flow.id == flow.id) ? true : false
        })
        return (page[0].layout == 'Question' || page[0].layout == 'IdealTextQuestion') ? true : false
      } catch (e) {
        return false
      }
    },
    getLocationIndex(record) {
      let index = 0
      if (record.bookmark !== null && record.bookmark.history) {
        _.each(record.bookmark.history, function (page) {
          if (page.state) {
            index++
          } else {
            if (page.id == record.bookmark.location) {
              index++
            }
          }
        })
      }
      return index
    },
    getSubSessionData(record) {
      try {

        if (this.subSessions.length <= 1) {

          return {pageIndex: this.getLocationIndex(record), count: this.activePageCount}

        } else {

          let activeSubSessionIndex = 0

          _.each(this.subSessions, function (subSession, index) {
            _.each(subSession, function (pageFlowId) {
              if (pageFlowId == record.bookmark.location) {
                activeSubSessionIndex = index
              }
            })
          })

          let pageIndex = this.subSessions[activeSubSessionIndex].findIndex((item) => item == record.bookmark.location) + 1
          return {pageIndex: pageIndex, count: this.subSessions[activeSubSessionIndex].length}
        }
      } catch (error) {
        return {pageIndex: 0, count: 0}
      }

    },
    disableChapterCheckbox(id) {
      let disableCheckboxes = document.getElementsByClassName('enable-disable-checkbox')
      if (id === null) {
        return
      }
      if (id === 0) { // at least 1 team has completed the session so we'll disable ALL checkboxes
        _.forEach(disableCheckboxes, function (checkbox) {
          checkbox.setAttribute('disabled', 'disabled')
        })
        return
      }
      // this will disable the chapter checkbox with the given id as well those preceeding it
      // this way we are sure to also prevent a facilitator from enabling a chapter that had been
      // disabled at the time a team had already passed it.
      let index = Array.prototype.findIndex.call(disableCheckboxes, function (e) {
        return e.value == id
      })

      for (var i = index; i >= 0; i--) {
        disableCheckboxes[i].setAttribute('disabled', 'disabled')
      }
    },
    enableChapterCheckboxes() {
      let disableCheckboxes = document.getElementsByClassName('enable-disable-checkbox')
      for (var i = 0; i < disableCheckboxes.length; i++) {
        disableCheckboxes[i].removeAttribute('disabled')
      }
    },
    updateRecord(record, hasTextResponses = false) {
      this.disableChapterCheckbox(record.chapter_id)

      const index = _.findIndex(this.records, {id: record.id})

      let that = this;

      if (index >= 0) { // found existing record to update

        if (this.records[index].bookmark == null) {
          this.records[index].bookmark = {}
          this.records[index].bookmark.textResponses = []
        }

        this.records[index].composite_score = _.sumBy(record.bookmark['metrics'], function (o) {
          return o.value
        })
        this.records[index].chapter_id = record.chapter_id

        this.records[index].bookmark.history = record.bookmark.history
        this.records[index].bookmark.progress = record.bookmark.progress
        this.records[index].bookmark.pageType = record.bookmark.pageType
        this.records[index].bookmark.location = record.bookmark.location
        this.records[index].bookmark.metrics = record.bookmark.metrics
        this.records[index].active_index = record.active_index
        this.records[index].lms = record.lms

        // We cannot send user text responses through Pusher due to Pusher's 10k limit.
        // Therefore, we'll have to hit the record endpoint anytime the pusher message contains a pageType of ideal-text-feedback
        if (record.bookmark.pageType == "ideal-text-feedback" ||
          record.bookmark.pageType == "OpenResponseQuestion" ||
          record.bookmark.pageType == "OpenResponseQuestionWithFeedback" ||
          record.bookmark.pageType == "OpenResponseQuestionAI"
        ) {
          axios.get('/api/record/' + record.id)
            .then((response) => {
              // update existing text responses
              that.records[index].bookmark.textResponses = response.data.bookmark.textResponses
            })
            .catch((err) => {
              console.error(err)
            })
        }

        // if the record payload explicitly contains text responses let's set them
        if (record.bookmark.textResponses && hasTextResponses) {
          this.records[index].bookmark.textResponses = record.bookmark.textResponses
        }

      } else { // adding new record to the list
        this.records.push(record)
      }
    },
    refreshRecordById(rid) {
      axios.get(`/api/record/${rid}`, {})
        .then(async (response) => {
          this.updateRecord(response.data, true)
        })
        .catch((response) => {
          console.error(response)
        })
    }
  },
  mounted() {
    this.calcActivePageCount(this.session.disabled_chapters)
    console.log(Echo)
    const channelPrefix = document.head.querySelector('meta[name="broadcast-channel-prefix"]')

    Echo.channel(channelPrefix.content + '.session.' + this.session.id)
      .listen('RecordUpdated', (e) => {
        console.log(e.record)
        this.updateRecord(e.record)
      })

    // The facilitator screen must listen to when a session is updated (i.e. pause/resume, chapter gates, resets, etc.)
    // because there may be multiple facilitator screens open and they need to be in sync
    Echo.channel(channelPrefix.content + '.session.' + this.session.id)
      .listen('SessionUpdated', (e) => {

        console.log('session edited')

        axios.get('/api/session/' + e.session.id)
          .then((response) => {
            // update session
            console.log(response)

            this.paused = response.data.paused
            this.gates = response.data.gates || []
            this.disabled_chapters = response.data.disabled_chapters || []
            this.calcActivePageCount(this.disabled_chapters)
          })
          .catch((err) => {
            console.error(err)
          })


      })

  }
}
